import type { ResultSource } from '../types';

export const STANDARD_RESULT_SOURCE: ResultSource = 'Standard';
export const MEDIA_INTELLIGENCE_RESULT_SOURCE: ResultSource =
  'MediaIntelligence';
